import { render, staticRenderFns } from "./Contactless.vue?vue&type=template&id=51a0ecb2&scoped=true&"
import script from "./Contactless.vue?vue&type=script&lang=ts&"
export * from "./Contactless.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0ecb2",
  null
  
)

export default component.exports